<template>
  <div :id="`${source}_complete_transfer_button`" class="w-full">
    <a-button
      @click="toCompleteTransfer"
      v-if="isWarmTransferEnabled && !isMerged"
      class="primary_medium gap-2 w-full"
      :loading="isCompletingTransfer"
      :disabled="!isTransferTargetActive || isCompletingTransfer"
    >
      <ThemeImage
        class="size-3"
        :icon="imageNames.TRANSFER_SELECTED"
        alt="transfer_icon"
      />
      Transfer Now
    </a-button>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { message } from "ant-design-vue";
import store from "@/src/store/index.js";
import CallService from "@/src/api/CallService.js";
import {imageNames} from "@/src/constants/imageConstants.js";

const props = defineProps({
  source: { type: String, required: true },
});

const isCompletingTransfer = ref(false);

const isWarmTransferEnabled = computed(
  () => store.getters["conferenceCall/isWarmTransfer"],
);
const isTransferTargetActive = computed(
  () => store.getters["conferenceCall/transferTargetActive"],
);
const isMerged = computed(() => store.getters["conferenceCall/isMerged"]);

const toCompleteTransfer = async () => {
  try {
    isCompletingTransfer.value = true;

    const payload = {
      conference_id: store.getters["conferenceCall/conferenceSid"],
    };

    const response = await CallService.completeTransfer(payload);
    if (response?.success) {
      message.success("Call transferred successfully!!");
      await store.dispatch("conferenceCall/endConference");
    }
  } catch (error) {
    console.error(
      "An error occurred while completing transfer button: ",
      error,
    );
  } finally {
    isCompletingTransfer.value = false;
  }
};
</script>
